import { useHistory } from 'react-router-dom';
import { Container, Anchor, IconLeft } from './_secondaryButton';

export const SecondaryButton = ({ children, iconLeft, href, ...props }) => {
  const history = useHistory();

  function renderIconLeft() {
    if (iconLeft) {
      return <IconLeft src={iconLeft} />;
    }
  }

  return (
    <>
      {!href && (
        <Container className="secondary-button" {...props}>
          {renderIconLeft()}
          {children}
        </Container>
      )}

      {href && (
        <Anchor
          onClick={() => history.push(href)}
          className="secondary-anchor"
          {...props}
        >
          {renderIconLeft()}
          {children}
        </Anchor>
      )}
    </>
  );
};
